import { createRoot } from "react-dom/client";
import { App } from "./app/App.js";
import { PageLoadBoundary } from "./app/PageLoadBoundary.js";
import "./styles/mobile.css";

createRoot(document.getElementById("root")!).render(<PageLoadBoundary><App /></PageLoadBoundary>);
